import React from 'react';
import {
  Button,
  Image,
  Modal,
  Stack,
} from 'react-bootstrap';
import Icon from 'components/DesignSystem/Icon';
import useKeyPress from 'hooks/useKeyPress';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function ImageModal({
  src,
  show,
  onHide,
  toFirst,
  toPrevious,
  toNext,
  toLast,
  up,
  down,
}: {
  src: string,
  show: boolean,
  onHide: () => void,
  toFirst?: () => void,
  toPrevious?: () => void,
  toNext?: () => void,
  toLast?: () => void,
  up?: () => void;
  down?: () => void;
}) {
  const showVerticalButtons = Boolean(up || down);
  const showHorizontalButtons = Boolean(toFirst || toPrevious || toNext || toNext);

  useKeyPress(['a', 'ArrowLeft'], toPrevious || (() => { }));
  useKeyPress(['d', 'ArrowRight'], toNext || (() => { }));
  useKeyPress(['w', 'ArrowUp'], up || (() => { }));
  useKeyPress(['s', 'ArrowDown'], down || (() => { }));
  useKeyPress(['End'], toLast || (() => { }));
  useKeyPress(['Home'], toFirst || (() => { }));

  return (
    <Modal
      centered
      show={show}
      onHide={onHide}
      className="image-modal"
    >
      {showVerticalButtons && (
        <Button variant="link" size="lg" disabled={up === undefined} onClick={up}>
          <Icon
            className="synoptic-charts-slider-control-button"
            iconType="up_arrow"
            color={cssVar('text-accent')}
          />
        </Button>
      )}
      <Stack direction="horizontal" className="image-container">
        {showHorizontalButtons && (
          <>
            <Button variant="link" size="lg" disabled={toFirst === undefined} onClick={toFirst}>
              <Icon
                className="synoptic-charts-slider-control-button"
                iconType="double_left_arrow"
                color={cssVar('text-accent')}
              />
            </Button>
            <Button variant="link" size="lg" disabled={toPrevious === undefined} onClick={toPrevious}>
              <Icon
                className="synoptic-charts-slider-control-button"
                iconType="left_arrow"
                color={cssVar('text-accent')}
              />
            </Button>
          </>
        )}
        <Image fluid alt="" src={src} className="image" />
        {showHorizontalButtons && (
          <>
            <Button variant="link" size="lg" disabled={toNext === undefined} onClick={toNext}>
              <Icon
                className="synoptic-charts-slider-control-button"
                iconType="right_arrow"
                color={cssVar('text-accent')}
              />
            </Button>
            <Button variant="link" size="lg" disabled={toLast === undefined} onClick={toLast}>
              <Icon
                className="synoptic-charts-slider-control-button"
                iconType="double_right_arrow"
                color={cssVar('text-accent')}
              />
            </Button>
          </>
        )}
      </Stack>
      {showVerticalButtons && (
        <Button variant="link" size="lg" disabled={down === undefined} onClick={down}>
          <Icon
            className="synoptic-charts-slider-control-button"
            iconType="down_arrow"
            color={cssVar('text-accent')}
          />
        </Button>
      )}
    </Modal>
  );
}
